import { useQuery } from '@tanstack/react-query'

import { MenuViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'
import { selectAPIService } from '@/app/_utils/select-api-service'

export function useLayoutMenu() {
    return useQuery<MenuViewModel>({
        queryKey: QueryKeys.Layout.LayoutMenu,
        queryFn: () => {
            const serviceName = selectAPIService().ntl

            return fetchRequest({ endpoint: `/layout/menu`, method: 'GET', serviceName })
        },
        refetchOnMount: false,
        retryOnMount: false,
    })
}
